// TODO remove this once lagoon is updated
export const cleanHref = (items) => {
  return items.map((item) => ({
    ...item,
    href:
      item.href && item.href.startsWith('#/') ? item.href.slice(1) : item.href,
  }));
};
